import type { HttpClient } from './http';
import type { TaskDefinition } from './types';

export interface TasksApi {
  list(select?: string[]): Promise<TaskDefinition[]>;
  categories(): Promise<string[]>;
  get(type: string): Promise<TaskDefinition>;
  icon(type: string): Promise<string>;
}

export function createTasksApi(http: HttpClient): TasksApi {
  return {
    list: (select?: string[]) =>
      http.get<TaskDefinition[]>(
        select ? `/tasks?select=${select.join(',')}` : `/tasks`
      ),
    categories: () => http.get<string[]>(`/tasks/categories`),
    get: (type: string) => http.get<TaskDefinition>(`/tasks/${type}`),
    icon: (type: string) => http.get<string>(`/tasks/${type}/icon`),
  };
}
